// URL path segments that indicate a locale route for a given region. Used to pre-select the appropriate region facet on initial load.
export const MARKET_URL_PATH_SEGMENTS: Record<string, string[]> = {
  Paris: ['/fr/', '/en-fr/'],
  Germany: ['/de/', '/en-de/'],
  Amsterdam: ['/nl/', '/en-nl/'],
  'United Kingdom': ['/gb/', '/en-gb/'],
};

// URL path segments that indicate a locale route for a given region. Used to pre-select the appropriate region facet on initial load.
export const REGION_URL_PATH_SEGMENTS: Record<string, string[]> = {
  europe: Object.values(MARKET_URL_PATH_SEGMENTS).flat(),
  australia: ['/en-au/', '/au/'],
  japan: ['/ja/', '/jp/', '/en-jp/', '/ja-jp/', '/en-ja/', '/jp-ja/'],
};

// Whether the current URL path contains any of the given path segments.
export const matchesUrlPath = (segments: string[]): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const path = window.location.pathname.toLowerCase();
  return segments.some((segment) => path.includes(segment));
};

// Resolves the market to pre-select based on the current URL path and locale, defaulting to undefined if no match is found.
export const getInitialMarket = (): string | undefined => {
  const locale = window.aqJobsOptions?.locale;
  const localeToMarket: Record<string, string> = {
    fr_FR: 'Paris',
    en_DE: 'Germany',
    en_NL: 'Amsterdam',
    en_GB: 'United Kingdom',
  };

  return localeToMarket[locale || '']
    || Object.keys(MARKET_URL_PATH_SEGMENTS).find((market) => matchesUrlPath(MARKET_URL_PATH_SEGMENTS[market]));
};

// Resolves the region to pre-select based on the current URL path and locale, defaulting to 'namerica' if no match is found.
export const getInitialRegion = (): string => {
  // Check if a region is explicitly set in the global options
  const siteRegion = window.aqJobsOptions?.region;
  if (siteRegion && siteRegion !== 'all') {
    return siteRegion;
  }

  return Object.keys(REGION_URL_PATH_SEGMENTS)
    .find((region) => matchesUrlPath(REGION_URL_PATH_SEGMENTS[region])) || 'namerica';
};

// Resolves the listing page's base URL, taking into account any locale prefix in the current URL path.
export const getListingBaseUrl = (): string => {
  const relativeListingUrl = window.aqJobsOptions?.relativeListingUrl || '/find-work';

  if (typeof window === 'undefined') {
    return relativeListingUrl;
  }

  const path = window.location.pathname;
  const prefixEnd = path.toLowerCase().indexOf(relativeListingUrl.toLowerCase());

  return prefixEnd > 0 ? `${path.slice(0, prefixEnd)}${relativeListingUrl}` : relativeListingUrl;
};
